import * as React from "react";
function SvgGridSquares(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 15 15"
      ref={svgRef}
      {...props}
    >
      <path d="M0 0v6.67h6.67V0H0zm5 5H1.67V1.67H5V5zM0 8.33V15h6.67V8.33H0zm5 5H1.67V10H5v3.33zM8.33 0v6.67H15V0H8.33zm5 5H10V1.67h3.33V5zm-5 3.33V15H15V8.33H8.33zm5 5H10V10h3.33v3.33z" />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgGridSquares);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
